import React from "react";
import { Box, Button, Typography } from "@mui/material";
import "./index.css";
import { Run, getStatusInString } from "../../../types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { parseTimeToLocal } from "../../../utils/timeHelper";

interface props {
  runs?: Run[];
}

const RunsBox: React.FC<props> = ({ runs }) => {
  const [data, setData] = React.useState<Run[]>([]);
  const [expand, setExpand] = React.useState<Boolean>(false);

  React.useEffect(() => {
    setData(
      runs?.filter((cur) => {
        return Number.isInteger(cur.runId);
      }) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box component="form" className={"runs-detail-form"}>
      <div>
        <Typography display="inline" className="runs-detail-form-title">
          {data.length} Runs:
        </Typography>
        <Button
          size="small"
          className="btn-collapsable"
          variant="contained"
          onClick={() => setExpand(!expand)}
        >
          {expand ? "Collapse" : "Expand"}
        </Button>
      </div>
      {expand && (
        <TableContainer component={Paper} className="table-runs">
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Run ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>End Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow
                  key={row.runId} // Use runId as a unique key (if it's unique)
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.runId + 1}
                  </TableCell>
                  <TableCell>{getStatusInString(row.status)}</TableCell>
                  <TableCell>{parseTimeToLocal(row.startTime)}</TableCell>
                  <TableCell>{parseTimeToLocal(row.endTime)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default RunsBox;
